import React from 'react';
import styled from 'styled-components';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';

const Container = styled.div`
  margin: auto;
`
const InputStyled = styled(Input)`
  width: 150px;
  background: #eee;
  border: 1px solid #ccc;
  padding: 5px;
  border-radius: 10px;
`

const InputField = ({
  type,
  ...other
}) => {

  const getInput = () => {
    switch(type) {
      case 'timed':
        return (
          <InputStyled
            type='number'
            disableUnderline
            endAdornment={<InputAdornment position="end">sec</InputAdornment>}
            {...other}
          />
        );
      case 'set_name':
        return (
          <InputStyled
            type='text'
            disableUnderline
            {...other}
          />
        );
      default:
        return (
          <InputStyled
            type='number'
            disableUnderline
            {...other}
          />
        );
    }
  }

  return (
    <Container>
      {getInput()}
    </Container>
  )
}

export default InputField;
